export default "__VITE_ASSET__B6v4EVME__"